module.exports = __webpack_public_path__ + "assets/img/wh5_p06.4698ff99.png";